import { callApi } from '@/api/callApi';
import { API_ENDPOINT, API_URL_ORDER_SERVICE } from '@/api/constant';
import CommonTable, { TableColumn } from '@/components/common/CommonTable';
import PageHeading from '@/components/common/PageHeading';
import Layout from '@/components/Layout/Layout';
import Card from '@/components/UI/Card';
import { useSelectableTable } from '@/hooks/useSelectableTable';
import {
  AbondenedData,
  AbondenedResponse,
} from '@/interfaces/abondenedCart.interface';
import { useEffect, useState } from 'react';

export interface IAbandonedCheckoutStates {
  checkouts: AbondenedResponse;
  isLoading: boolean;
}

const AbandonedCheckouts: React.FC = () => {
  const [state, setState] = useState<IAbandonedCheckoutStates>({
    checkouts: {
      data: [],
      totalPages: 1,
      totalRecords: 1,
    },
    isLoading: false,
  });

  const { selectedItems, handleSelectAll, handleSelectItem } =
    useSelectableTable(state.checkouts.data);

  const abandonedCheckoutColumns: TableColumn<AbondenedData>[] = [
    {
      key: 'customer',
      header: 'Customer',
      render: (checkout) => `${checkout?.userDetail?.fullName}`,
    },
    {
      key: 'email',
      header: 'Email',
      render: (checkout) => (
        <a
          href={`mailto:${checkout?.userDetail?.email}`}
          className="text-indigo-600 hover:underline"
        >
          {checkout?.userDetail?.email}
        </a>
      ),
    },
    {
      key: 'total',
      header: 'Total Amount BD',
      render: (checkout) => `${checkout.cartValue.toFixed(3)} BD`,
    },
    {
      key: 'items',
      header: 'Items',
      render: (checkout) => checkout.cartDetails.length,
    },
  ];

  // const actions: Action<AbandonedCheckout>[] = [
  //   {
  //     text: 'View',
  //     onClick: (checkout: AbandonedCheckout) => {
  //       console.log('Viewing checkout:', checkout.id);
  //     },
  //   },
  // ];

  useEffect(() => {
    fetchAbandonedCheckouts();
  }, []);

  const fetchAbandonedCheckouts = async () => {
    try {
      setState((prev) => ({
        ...prev,
        isLoading: true,
      }));
      const PATH = `${API_URL_ORDER_SERVICE}${API_ENDPOINT.cart}/abondened-carts`;
      const res = await callApi<AbondenedResponse>(PATH, {
        method: 'GET',
      });
      setState((prev) => ({
        ...prev,
        checkouts: res,
        isLoading: false,
      }));
    } catch (error) {
      // console.error('Failed to fetch abandoned checkouts:', error);
      setState((prev) => ({
        ...prev,
        isLoading: false,
      }));
    }
  };

  return (
    <Layout>
      <PageHeading text="Abandoned Checkouts" />
      <Card>
        <CommonTable
          columns={abandonedCheckoutColumns}
          data={state.checkouts.data}
          showCheckbox={false}
          selectedItems={selectedItems}
          onSelectAll={handleSelectAll}
          onSelectItem={handleSelectItem}
          getItemId={(item) => item.id}
          emptyMessage="No Abandoned Checkouts found"
          loading={state.isLoading}
        />
      </Card>
    </Layout>
  );
};

export default AbandonedCheckouts;
